import type { AwardState as PillState } from '@cou/admin-ui';

/**
 * Maps the backend's Award status (game-logic.md, the Award state table) onto the admin-ui
 * StatusPill's lowercase state set, mirroring contests/state-pill.ts. An unrecognised status reads
 * as `pending` — the most neutral pill — rather than throwing a whole Awards list away over one
 * unknown row.
 */
export function awardPillState(status: string): PillState {
  const key = status.toLowerCase();
  return key === 'processing' ||
    key === 'delivered' ||
    key === 'retryable' ||
    key === 'failed' ||
    key === 'canceled'
    ? key
    : 'pending';
}
